import { ciPhaseRunner } from '../ciStages/ciPhaseRunner'
import { getCiConfiguration } from '../configuration/configuration'
import { CiPhase, CiStage } from '../configuration/interface'

export type cliStageOptions = {
  stage: CiStage,
  phase: CiPhase,
  config: string,
}

const cliStage = async (options: cliStageOptions) => {
  const { stage, phase, config: configFile } = options

  // Get config
  const ciConfig = await getCiConfiguration(configFile)

  // Validate stage and phase args
  // Obsolete since cli validates this
  if (!stage || !['deploy', 'build', 'stop', 'revert'].includes(stage) || !phase || !['before', 'main', 'after'].includes(phase)) {
    throw Error(`Missing or invalid stage or phase arguments`)
  }

  await ciPhaseRunner(ciConfig, stage, phase)
}

export default cliStage